<template>
  <div class="p_doc_box">
    <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
        </div>
    </div>
    <div class="main-con">
        <div class="crumbs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>知识库</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/document' }">使用指南</el-breadcrumb-item>
                <el-breadcrumb-item v-if="type=='custom'">使用手册</el-breadcrumb-item>
                <el-breadcrumb-item v-if="type=='report' && level == '1'">利润报表使用手册</el-breadcrumb-item>
                <el-breadcrumb-item v-if="type=='report' && level == '2'">利润报表使用手册1.0</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="p_doc_content">
            <p class="doc_txt" v-if="type=='custom'">使用手册</p>
            <p class="doc_txt" v-if="type=='report' && level == '1'">利润报表使用手册</p>
            <p class="doc_txt" v-if="type=='report' && level == '2'">利润报表使用手册1.0</p>
            <!-- <div class="doc_btn">
                <el-button type="success" size="small" @click="onDownloadFile">下载</el-button>
            </div> -->
            <div class="p_pdf_box">
                <!-- currentPage" // 当前展示的PDF页码 pageCount=$event" // PDF文件总页码 -->
                <!-- <pdf
                :src="pdfSrc"
                :page="currentPage"
                @num-pages="pageCount=$event"
                @page-loaded="currentPage=$event"
                @loaded="loadPdfHandler">
                </pdf> -->
                <div v-if="type=='report' && level == '1'">
                  <pdf v-for="i in numPages2"
                  :key="i"
                  :src="pdfSrc2"
                  :page="i" style="width:100%" ref="pdf"></pdf>
                </div>
                <div v-if="type=='report' && level == '2'">
                  <pdf v-for="i in numPages3"
                  :key="i"
                  :src="pdfSrc3"
                  :page="i" style="width:100%" ref="pdf"></pdf>
                </div>
                <div v-if="type=='custom'">
                  <pdf v-for="i in numPages1"
                  :key="i"
                  :src="pdfSrc1"
                  :page="i" style="width:100%" ref="pdf"></pdf>
                </div>
                </div>
            <!-- <el-tabs :tab-position="tabPosition">
                <el-tab-pane label="使用指南"></el-tab-pane>
            </el-tabs> -->
        </div>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf' //引入下载的vue-pdf
import { download } from '@/utils' //封装的下载方法
var path1 = location.origin + '/cloudimg/helpfile/%E6%9D%B0%E5%8D%9A%E6%95%B0%E5%AD%97%E5%8C%96%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf'
var path2 = location.origin + '/cloudimg/helpfile/%E5%88%A9%E6%B6%A6%E6%8A%A5%E8%A1%A8%E6%9F%A5%E7%9C%8B%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf'
var path3 = location.origin + '/cloudimg/helpfile/%E5%88%A9%E6%B6%A6%E6%8A%A5%E8%A1%A8%E6%9F%A5%E7%9C%8B%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C1.0%281%29.pdf'
var loadingTask1 = pdf.createLoadingTask(path1);
var loadingTask2 = pdf.createLoadingTask(path2);
var loadingTask3 = pdf.createLoadingTask(path3);
export default {
    components: {
        pdf
    },
  data() {
    return {
        currentPage: 0, // pdf文件页码
        pageCount: 0, // pdf文件总页数
        fileType: 'pdf', // 文件类型
        pdfSrc1:loadingTask1,
        pdfSrc2:loadingTask2,
        pdfSrc3:loadingTask3,
        numPages1: undefined,
        numPages2: undefined,
        numPages3: undefined,
        type:'',
        level:1
    }
  },
  created() {
    this.type = this.$route.query.type
    this.level = this.$route.query.level
    // this.pdfSrc = 'https://emp.jobkeji.cn/cloudimg/helpfile/%E6%9D%B0%E5%8D%9A%E6%95%B0%E5%AD%97%E5%8C%96%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf'
    // 有时PDF文件地址会出现跨域的情况,这里最好处理一下
    // this.pdfSrc = pdf.createLoadingTask(this.pdfSrc)
  },
  mounted() {
    if(this.type == 'report'){
      if(this.level == '1'){
        this.pdfSrc2.promise.then(pdf => {
          this.numPages2 = pdf.numPages
        })
      }else{
        this.pdfSrc3.promise.then(pdf => {
        this.numPages3 = pdf.numPages
      })
      }
    }else{
      this.pdfSrc1.promise.then(pdf => {
        this.numPages1 = pdf.numPages
      })
    }
  },
  methods: {
    // pdf加载时 
    loadPdfHandler (e) {
    this.currentPage = 1 // 加载的时候先加载第一页
    },
    getpdfpage() {
      let loadingTask = pdf.createLoadingTask(this.pdfSrc)
      loadingTask.promise
        .then((pdf) => {
          this.numPages = pdf.numPages
        })
        .catch((err) => {
          console.error("失败", err)
        });
    },
    //下载pdf
    onDownloadFile() {
        download(this.pdfSrc)
    }
  }
};
</script>

<style>
.p_doc_content{
    padding: 20px;
    background-color: #fff;
}
</style>
<style scoped>
.p_doc_content .doc_txt{
    padding: 0 0 10px;
    text-align: center;
    font-size: 16px;
    color:#333;
    border-bottom: 1px dashed #ddd;
}
.doc_btn{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}
.p_doc_content{
    min-height: 800px;
    padding: 20px;
    background-color: #fff;
}
.el-pagination{
  background-color: #fff;
}
</style>